import { createSlice } from "@reduxjs/toolkit";

export const disease_main_crop_affected = createSlice({
  name: "disease_main_crop_affected",
  initialState: {
    value: {
      status: false,
      cropSelected: {},
    },
  },
  reducers: {
    //create first data item
    updateMainCropAffected: (state, action) => {
      state.value.status = true;
      state.value.cropSelected = action.payload;
    },
  },
});

export const { updateMainCropAffected } = disease_main_crop_affected.actions;

export default disease_main_crop_affected.reducer;
